import JSONTree from 'react-json-tree';
import { React, PT, fetchApi } from '@gasbuddy/react';
import { Modal, Header, Form, Dropdown, Button, Icon, Message, List, Input } from 'semantic-ui-react';

const reasonOptions = [
  { value: 'inactive', text: 'Transaction occurred on an invalid card' },
  { value: 'fraud', text: 'The user did not authorize this transaction' },
  { value: 'double', text: 'The user was double charged' },
  { value: 'negative', text: 'A balance is due the customer' },
  { value: 'duplicate', text: 'This is a duplicate transaction' },
  { value: 'zero', text: 'Discounts need to be reduced to make transaction $0' },
  { value: 'bankruptcy', text: 'Customer is legally bankrupt' },
  { value: 'writeoff', text: 'GasBuddy is giving up on collection' },
  { value: 'refund', text: 'GasBuddy refunds the customer (e.g. membership)' },
  { value: 'increaseloss', text: 'Increase the loss to balance the transaction' },
  { value: 'partial', text: 'Partial refund' },
];

export class RefundModal extends React.Component {
  state = {}

  loadAndGo = () => {
    this.setState({ opened: true });
  }

  callApi = () => {
    const { reason, memo, credit, dispute, dryRun, amount, seperateTransaction } = this.state;
    const { accountId, transactionId, onRefund } = this.props;
    this.setState({ }, async () => {
      const { body, status, error } = await fetchApi({
        url: `/payments/transaction/${accountId}/${transactionId}/refund`,
        catchErrors: true,
        body: {
          reason,
          memo,
          credit,
          dispute,
          dry_run: !dryRun,
          amount,
          seperateTransaction,
        },
      });
      if (error || status !== 200) {
        this.setState({ dryRun: null, error: body || error });
      } else if (!dryRun) {
        this.setState({ dryRun: body, error: null });
      } else {
        this.setState({ opened: false, dryRun: null, error: null });
        onRefund();
      }
    });
  }

  render() {
    const { dryRun, opened, reason, memo, error, amount, credit } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button onClick={this.loadAndGo}>Refund Transaction</Button>}
      >
        <Header icon="attention" content="Describe the Refund" />
        <Modal.Content>
          {dryRun
            && (
            <Message>
              <Message.Content>
                <List>
                  <List.Header>Actions to be taken:</List.Header>
                  {(dryRun.log || []).map(l => (
                    <List.Item>
                      {l.message}
&nbsp;
                      {l.value && `(${l.value})`}
                    </List.Item>
                  ))}
                </List>
                <JSONTree hideRoot data={dryRun} />
              </Message.Content>
            </Message>
            )
          }
          {error
            && (
            <Message negative>
              <Message.Content>
                <List>
                  <List.Header>Cannot complete refund:</List.Header>
                  {(error.log || []).map(l => (
                    <List.Item>
                      {l.message}
&nbsp;
                      {l.value && `(${l.value})`}
                    </List.Item>
                  ))}
                </List>
                <JSONTree hideRoot data={error} />
              </Message.Content>
            </Message>
            )
          }
          <Form>
            <Form.Field>
              <Dropdown
                placeholder="Select a reason for the refund"
                value={reason}
                options={reasonOptions}
                onChange={(e, el) => {
                  const newReason = el.value;
                  // If partial is selected, auto-check credit and seperateTransaction options
                  if (newReason === 'partial') {
                    this.setState({
                      dryRun: false,
                      reason: newReason,
                      credit: true,
                      seperateTransaction: true,
                      // Don't set amount here - let the user input it
                    });
                  } else {
                    this.setState({
                      dryRun: false,
                      reason: newReason,
                      // Clear amount if switching from partial to another reason
                      amount: newReason !== 'partial' && reason === 'partial' ? undefined : amount,
                    });
                  }
                }}
                search
                selection
              />
            </Form.Field>
            {reason === 'partial' && (
              <Form.Field>
                <Input
                  label="Amount $"
                  value={amount}
                  onChange={(e) => {
                    const { value } = e.target;
                    // Allow input that will result in valid currency format
                    if (value === ''
                      || /^\d+$/.test(value)
                      || /^\d+\.$/.test(value)
                      || /^\d+\.\d{1,2}$/.test(value)) {
                      this.setState({ dryRun: false, amount: value });
                    }
                  }}
                  onBlur={(e) => {
                    // Format to exactly 2 decimal places on blur
                    const { value } = e.target;
                    if (value) {
                      const num = parseFloat(value);
                      if (!Number.isNaN(num)) {
                        this.setState({ amount: num.toFixed(2) });
                      }
                    }
                  }}
                  placeholder="0.00"
                  type="text"
                />
              </Form.Field>
            )}
            <Form.TextArea
              rows={3}
              value={memo}
              onChange={e => this.setState({ dryRun: false, memo: e.target.value })}
              label="Memo"
            />
            <Form.Checkbox
              label="Issue any refunds as account credit"
              checked={reason === 'partial' ? true : credit}
              onChange={(d, v) => this.setState({ dryRun: false, credit: v.checked })}
              disabled={reason === 'partial'}
            />
            <Form.Group>
              <Form.Checkbox
                label="Create a dispute with Wex"
                onChange={(d, v) => this.setState({ dryRun: false, dispute: v.checked })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Checkbox
                label="Payout Credit as seperate transaction"
                checked={reason === 'partial'}
                onChange={(d, v) => this.setState({ seperateTransaction: v.checked })}
                disabled
              />
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
Cancel
          </Button>
          {dryRun
            && (
            <Button basic color="red" onClick={this.callApi}>
              <Icon name="money" />
              {' '}
Refund Transaction
            </Button>
            )
          }
          {!dryRun
            && (
            <Button basic color="red" onClick={this.callApi}>
              <Icon name="money" />
              {' '}
Preview Refund Actions
            </Button>
            )
          }
        </Modal.Actions>
      </Modal>
    );
  }
}

RefundModal.propTypes = {
  accountId: PT.number,
  transactionId: PT.number,
  onRefund: PT.func.isRequired,
};

RefundModal.defaultProps = {
  transactionId: 0,
  accountId: 0,
};
